<template>
  <div v-on:click="preview" class="music-preview" v-bind:class="{ 'playing' : playing }">
    <span>Preview</span>
    <div class="icon"></div>
  </div>
</template>

<script>
import {Howl, Howler} from 'howler';

export default {
  name: "MusicPreview",
  props: ["clip"],
  data() {
    return {
      playing: false
    }
  },
  methods: {
    preview: function() {
      let previewFilename = this.clip.filename + "_16." + this.clip.format;
      if (this.sound && this.sound.playing()) {
        this.sound.stop();
        this.playing = false;
      } else {
        this.sound = new Howl({
          src: ['/music/'+previewFilename]
        });
        this.sound.play();
        this.playing = true;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.music-preview
  width: auto
  padding: 0px 10px
  margin: auto auto 15px auto
  font-size: 9px
  border: 1px solid #FFF
  border-radius: 10px
  display: flex
  align-items: center
  .icon
    width: 10px
    height: 20px
    cursor: pointer
    margin-left: 5px
    background-image: url(../../assets/images/play-icon.svg)
    background-repeat: no-repeat
    background-size: 8px auto
    background-position: left center
  &.playing
    .icon
      background-image:url('../../assets/images/pause-icon.svg')
      background-position: left center
      background-size: 10px auto
</style>
